import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, Stack } from "@mui/material"
import type { DateTime } from "luxon"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ProductionDateButton } from "../../../../merchant/merchant/production/meetingService/productionView/components/ProductionDateButton"

const useStyles = makeStyles()((theme) => ({
    navButton: {
        width: "3rem",
        height: "3rem",
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
        borderRadius: ".75rem",
        background: theme.palette.background.paper,
        color: theme.palette.tailwind.slate[800],
        "& svg": {
            fontSize: ".875rem",
        },
    },
}))

type Props = Readonly<{
    date: DateTime
    onDateChange: (date: DateTime) => void
}>

export function MeetingRoomsDayNavigator({ date, onDateChange }: Props) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" alignItems="center" spacing=".5rem">
            <LocalizedStrict id="service-center-meeting-rooms-previous-day-button" attrs={{ "aria-label": true }}>
                <IconButton
                    aria-label="Previous day"
                    className={classes.navButton}
                    onClick={() => onDateChange(date.minus({ days: 1 }))}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </IconButton>
            </LocalizedStrict>
            <ProductionDateButton selectedDate={date} onDateChange={(value) => onDateChange(value.startOf("day"))} />
            <LocalizedStrict id="service-center-meeting-rooms-next-day-button" attrs={{ "aria-label": true }}>
                <IconButton
                    aria-label="Next day"
                    className={classes.navButton}
                    onClick={() => onDateChange(date.plus({ days: 1 }))}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </IconButton>
            </LocalizedStrict>
        </Stack>
    )
}
